import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PackagePurchase = () => {
  const [username, setUsername] = useState("");
  const [amount, setAmount] = useState("");
  const [packageId, setPackageId] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [existUsername, setExistUsername] = useState();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const { data, error } = await apiCall("GET", "/getAllPackage");
        if (error) {
          toast.error(error.message || "Failed to load packages");
          return;
        }
        // API shape: { packages: [ { planId, packages: [ {...}, ... ] } ] }
        let list = [];
        if (Array.isArray(data?.packages)) {
          for (const plan of data.packages) {
            if (Array.isArray(plan?.packages) && plan.packages.length > 0) {
              list.push(...plan.packages);
            } else {
              list.push(plan);
            }
          }
        } else if (Array.isArray(data?.data)) {
          list = data.data;
        }
        setPackageData(list);
      } catch (e) {
        console.log(e);
      }
    };
    fetchPackages();
  }, []);

  const isUserExist = async () => {
    setLoading(true);

    if (!username) {
      setExistUsername(". . .");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: username,
      });
      if (data) {
        setExistUsername(data.name);
      } else if (error) {
        setExistUsername("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000)
    );

    return () => clearTimeout(typingTimeout);
  }, [username]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!username || !packageId || amount === "" || Number.isNaN(Number(amount))) {
      toast.error("Please fill in all fields");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall(
        "POST",
        "/activate_user",
        {
          username: username.trim(),
          amount: Number(amount),
          packageId: packageId,
        },
        true
      );

      if (data) {
        setUsername("");
        setAmount("");
        setPackageId("");
        setExistUsername("");
      } else if (error) {
        // toast handled by apiCall when 4th arg true
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Container className="mt-4">
        <section id="package-purchase-section">
          <div className="d-flex justify-content-center">
            <h2>Package Purchase</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={handleSubmit}>
                    <div id="formFields">
                      <div className="mb-3">
                        <div className="d-flex">
                          <label htmlFor="username">User Name:</label>
                          <label
                            style={{ textAlign: "end" }}
                            htmlFor="username"
                          >
                            {loading && username ? "Loading..." : existUsername}
                          </label>
                        </div>
                        <input
                          type="text"
                          id="username"
                          className="form-control"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Enter your Username"
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="packageSelect">Select Package</label>
                        <select
                          className="form-control selectBox"
                          id="packageSelect"
                          value={packageId}
                          onChange={(e) => {
                            const val = e.target.value;
                            setPackageId(val);
                            const x = packageData.find(
                              (p) =>
                                String(
                                  p?.packageId ?? p?._id ?? p?.planId ?? ""
                                ) === String(val)
                            );
                            if (x) {
                              const amt =
                                x?.amount ??
                                x?.price ??
                                x?.package_amount ??
                                "";
                              if (amt !== "" && amt != null) {
                                setAmount(String(amt));
                              }
                            }
                          }}
                        >
                          <option value="">--Select Package--</option>
                          {Array.isArray(packageData) &&
                            packageData.map((x, i) => {
                              const id = x?.packageId ?? x?._id ?? x?.planId;
                              if (id == null || id === "") return null;
                              const label =
                                x?.packageName ??
                                x?.package_name ??
                                x?.name ??
                                "Package";
                              const amt =
                                x?.amount ?? x?.price ?? x?.package_amount;
                              const text =
                                amt != null && amt !== ""
                                  ? `${label} (${amt})`
                                  : label;
                              return (
                                <option key={i} value={String(id)}>
                                  {text}
                                </option>
                              );
                            })}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label htmlFor="amount">Amount:</label>
                        <input
                          type="number"
                          id="amount"
                          className="form-control"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter Amount"
                        />
                      </div>

                      <Button
                        type="submit"
                        variant="primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                      <Button
                        variant="secondary"
                        className="ms-2"
                        type="button"
                        onClick={() => {
                          setUsername("");
                          setAmount("");
                          setPackageId("");
                          setExistUsername("");
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
      </Container>
    </React.Fragment>
  );
};

export default PackagePurchase;
